module.exports = __webpack_public_path__ + "static/media/siddharth-iphone.73a2fc0f.jpg";